import React from 'react';

import { IconProps } from 'icons/Icon.types';

export function ArrowSorter({ size, color }: IconProps) {
  return (
    <svg
      width={size ?? 24}
      height={size ?? 24}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <title>ArrowSorter</title>
      <path
        d="M8.29648 9.88253L10.8865 7.29253C11.2765 6.90253 11.9065 6.90253 12.2965 7.29253L14.8865 9.88253C15.5165 10.5125 15.0665 11.5925 14.1765 11.5925H8.99648C8.10648 11.5925 7.66648 10.5125 8.29648 9.88253Z"
        fill={color ?? 'currentColor'}
      />
      <path
        d="M8.29648 15.3025L10.8865 17.8925C11.2765 18.2825 11.9065 18.2825 12.2965 17.8925L14.8865 15.3025C15.5165 14.6725 15.0665 13.5925 14.1765 13.5925H8.99648C8.10648 13.5925 7.66648 14.6725 8.29648 15.3025Z"
        fill={color ?? 'currentColor'}
      />
    </svg>
  );
}
